module.exports = __webpack_public_path__ + "static/media/last_round_bell.d8dca092.png";